class EmailPopup {
	private isOpen = false;
	private currentEmail = '';
	private popup: HTMLElement | null = null;
	private closeButton: HTMLElement | null = null;
	private acceptButton: HTMLButtonElement | null = null;
	private cancelButton: HTMLButtonElement | null = null;

	constructor() {
		this.handleEmailClick = this.handleEmailClick.bind(this);
		this.handleCloseClick = this.handleCloseClick.bind(this);
		this.handleAcceptClick = this.handleAcceptClick.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);
	}

	init() {
		this.popup = document.querySelector('.email-popup');
		this.closeButton = document.querySelector('.email-popup__close');
		this.acceptButton = document.querySelector('.email-popup__button--accept');
		this.cancelButton = document.querySelector('.email-popup__button--cancel');

		if (!this.popup) return;

		document.body.addEventListener('click', this.handleEmailClick);
		document.addEventListener('keydown', this.handleKeyPress);

		this.closeButton?.addEventListener('click', this.handleCloseClick);
		this.cancelButton?.addEventListener('click', this.handleCloseClick);
		this.acceptButton?.addEventListener('click', this.handleAcceptClick);
	}

	private handleEmailClick(event: MouseEvent) {
		const target = event.target as HTMLElement;
		const anchor = target.closest<HTMLAnchorElement>('a[href*="mailto:"][href*="@"]');

		if (!anchor) return;

		event.preventDefault();

		const href = decodeURIComponent(anchor.href);
		const email = href.substring(7); // Remove "mailto:"

		this.currentEmail = email;
		this.openPopup();
	}

	private handleAcceptClick() {
		if (this.currentEmail) {
			window.location.href = `mailto:${this.currentEmail}`;
		}
		this.closePopup();
	}

	private openPopup() {
		if (!this.popup || this.isOpen) return;

		this.popup.classList.add('is-open');
		document.body.classList.add('scroll-lock');
		this.isOpen = true;

		this.closeButton?.focus();
	}

	private handleCloseClick(event: Event) {
		event.preventDefault();
		this.closePopup();
	}

	private handleKeyPress(event: KeyboardEvent) {
		if (event.key === 'Escape' && this.isOpen) {
			this.closePopup();
		}
	}

	private closePopup() {
		if (!this.popup || !this.isOpen) return;

		this.popup.classList.remove('is-open');
		document.body.classList.remove('scroll-lock');
		this.isOpen = false;
		this.currentEmail = '';
	}
}

const emailPopup = new EmailPopup();
emailPopup.init();
